export default {
    finance: 'Finanzverwaltung',
    cost_center: 'Kostenstelle',
    data_center: 'Campus IT',
    tech_department: 'Campus Technik',
    additional_approvals: 'Zusätzliche Genehmigungen',
    decision_dc_td: 'Entscheidung CIT/CT',

    noneRequired: 'keine erforderlich',
    notDecided: 'Nicht entschieden',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    correct: 'Korrektur',
    finalReject: 'Endgültig ablehnen',
    requestCorrection: 'Korrektur anfordern',
    requestedCorrection: 'Korrektur angefordert',
    approved: 'genehmigt',
    rejected: 'abgelehnt',
    correction: 'zu korrigieren',
    none: 'keine',
    open: 'offen',
    decisionUnknown: 'Entscheidung unbekannt',

    department: 'Fachbereich',
    user: 'Genehmigender',
    decision: 'Entscheidung',
    explanation: 'Begründung',
    time: 'Zeitpunkt',

    rejectionInfoOne: 'Durch Ihre Ablehnung wird der Antrag abgelehnt und die beschaffende Person wird über Ihre Entscheidung informiert.',
    rejectionInfoTwo: 'Der Beschaffungsprozess wird beendet und der vorliegende Antrag kann nicht mehr bearbeitet werden.',
    rejectionInfoThree: 'Sie können stattdessen auch eine Korrektur bei dem Beschaffer anfordern.',

    correctionInfoOne: 'Sie können die beschaffende Person auffordern, den Antrag zu korrigieren. Die beschaffende Person wird über Ihre Entscheidung informiert und der Antrag wird zur Korrektur zurückgegeben.',
    correctionInfoTwo: 'Der Beschaffungsantrag muss daraufhin erneut alle notwendigen Genehmigungen durchlaufen.',

    approvalInfo: 'Durch Ihre Genehmigung stimmen Sie der Richtigkeit und Vollständigkeit des Antrags zu. Die beschaffende Person wird über Ihre Entscheidung informiert und die Beschaffung wird fortgesetzt.',

    shouldOrderBeRejected: 'Möchten Sie diesen Beschaffungsantrag endgültig ablehnen?',
    shouldOrderBeCorrected: 'Möchten Sie eine Korrektur anfordern?',
    shouldOrderBeApproved: 'Möchten Sie diesen Beschaffungsantrag genehmigen?',
    approvalError: 'Genehmigungsfehler',
    approvalErrorDescription: 'Die Beschaffung konnte nicht genehmigt werden.',

    confirmSelection: 'Auswahl bestätigen',
    decisionExplanation: 'Sie können entscheiden, ob für diesen Beschaffungsantrag zusätzliche Genehmigungen erforderlich sind. Wählen Sie eine der folgenden Optionen um den Genehmigungsprozess in den nächsten Schritt zu bringen.',
    approvalExplanation: 'Dieser Beschaffungsantrag benötigt Ihre Genehmigung. Bitte überprüfen Sie die Details und entscheiden Sie über die Freigabe.'
}